<template>    
  <div
    class="results-table__cell"
    :title="docData[cellData.dataFields[0]]"
  >
    {{ docData[cellData.dataFields[0]] }}
  </div>
</template>

<script>
import { cellMixins } from './mixins'

export default {
  mixins: [cellMixins]
};
</script>
